export default function AppErrorMessage({ message = 'Something went wrong' }: Readonly<{ message?: string }>) {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        width: '33%',
      }}
    >
      <div style={{ color: '#ff0000', border: '1px solid #ff0000', padding: '1rem' }}>
        <span>{message}</span>
      </div>
    </div>
  );
}
